import { useState } from "react";

interface ShareModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
}

const channels = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-qq-fill", label: "QQ" },
  { icon: "ri-links-line", label: "复制链接" },
];

export default function ShareModal({ open, title, onClose }: ShareModalProps) {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const shareText = `《${title}》- 亚洲一区二区在线`;

  const handleChannel = async (label: string) => {
    if (label === "复制链接") {
      try {
        await navigator.clipboard.writeText(shareText);
      } catch {
        // clipboard may be unavailable
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-foreground-950/60 px-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-lg bg-background-50 p-5"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-lg font-bold text-foreground-950">分享给好友</h3>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        <p className="mt-1 truncate text-sm text-foreground-500">{shareText}</p>

        <div className="mt-5 grid grid-cols-4 gap-3">
          {channels.map((channel) => (
            <button
              key={channel.label}
              type="button"
              onClick={() => handleChannel(channel.label)}
              className="flex flex-col items-center gap-2 rounded-md p-2 transition-colors hover:bg-background-100"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-50 text-primary-600">
                <i className={`${channel.icon} text-xl`}></i>
              </span>
              <span className="text-xs text-foreground-600">{channel.label}</span>
            </button>
          ))}
        </div>

        {copied && (
          <p className="mt-4 flex items-center justify-center gap-1 rounded-md bg-background-100 py-2 text-xs text-primary-600">
            <i className="ri-check-line"></i>
            分享内容已复制到剪贴板
          </p>
        )}
        <p className="mt-4 text-center text-xs text-foreground-400">
          本站为演示站点，分享链接仅为功能演示
        </p>
      </div>
    </div>
  );
}